module.exports = __webpack_public_path__ + "47f05d7bf51af9a60b97e26b04f63154.svg";